module.exports = __webpack_public_path__ + "static/media/level4.52824046.svg";